<div class="page-body">
  <div *ngIf="loading">
    <app-spinner></app-spinner>
  </div>

  <div *ngIf="!loading" class="contents-wrapper">
    <div class="contents-container">
      <p class="heading">{{ state.interruptionDetails.heading }}</p>
      <p class="info-text">{{ state.interruptionDetails.message }}</p>
      <div class="button-wrapper">
        <zaver-secondary-button-outlined
          *ngIf="state.interruptionDetails?.ctaLabel"
          class="rejection-button"
          [text]="state.interruptionDetails?.ctaLabel"
          [rounded]="true"
          [disabled]="navigationInProgress"
          (click)="handleCtaClick()"
        ></zaver-secondary-button-outlined>

        <zaver-secondary-button-outlined
          *ngIf="state.interruptionDetails?.ctaBlackLabel"
          class="rejection-button"
          [text]="state.interruptionDetails?.ctaBlackLabel"
          [rounded]="true"
          [disabled]="navigationInProgress"
          (click)="handleCtaBlackClick()"
        ></zaver-secondary-button-outlined>
      </div>
    </div>
  </div>
</div>
